import { memo } from 'react';
import { ChevronDownOutlined } from '@JohnLewisPartnership/jl-design-system/components/icons/ChevronDownOutlined';
import { ChevronUpOutlined } from '@JohnLewisPartnership/jl-design-system/components/icons/ChevronUpOutlined';

type ChevronIconProps = {
  isOpen: boolean;
  testId: string;
};

export const ChevronIcon = memo<ChevronIconProps>(({ isOpen, testId }) =>
  isOpen ? (
    <ChevronUpOutlined dataTestId={`${testId}-up`} />
  ) : (
    <ChevronDownOutlined dataTestId={`${testId}-down`} />
  )
);

ChevronIcon.displayName = 'ChevronIcon';
